import * as React from 'react';
import { ShieldCheck, ShieldOff } from 'lucide-react';
import { Badge } from './badge';

export interface TwoFactorStatusBadgeProps {
  enabled: boolean;
  className?: string;
}

export const TwoFactorStatusBadge: React.FC<TwoFactorStatusBadgeProps> = ({ enabled, className }) => {
  if (enabled) {
    return (
      <Badge className={`bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 ${className ?? ''}`}>
        <ShieldCheck className="h-3 w-3 mr-1" />
        2FA attivo
      </Badge>
    );
  }
  return (
    <Badge className={`bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-300 ${className ?? ''}`}>
      <ShieldOff className="h-3 w-3 mr-1" />
      2FA assente
    </Badge>
  );
};
